import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Flame, ShieldCheck } from 'lucide-react';
const phases = [{
  icon: Droplets,
  phase: 'Fase 1',
  days: 'Días 1-7',
  title: 'Detox Hepático',
  description: 'Limpieza profunda del hígado para que pueda procesar estrógenos correctamente. Reducción de inflamación y retención de líquidos.',
  color: 'text-blue-600',
  bg: 'bg-blue-50'
}, {
  icon: Flame,
  phase: 'Fase 2',
  days: 'Días 8-14',
  title: 'Reset de Insulina',
  description: 'Protocolo de Ayuno 14:10 y ciclo estratégico de carbohidratos para despertar tu metabolismo dormido.',
  color: 'text-orange-600',
  bg: 'bg-orange-50'
}, {
  icon: ShieldCheck,
  phase: 'Fase 3',
  days: 'Días 15-21',
  title: 'Estabilización',
  description: 'Sellar la integridad intestinal y establecer un nuevo set point metabólico para resultados permanentes.',
  color: 'text-green-600',
  bg: 'bg-green-50'
}];
export function ProtocolSection() {
  return <section className="py-24 bg-white" data-id="element-168">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-170">
          <span className="text-[#0D6B4F] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-171">
            LA SOLUCIÓN CIENTÍFICA
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1F2937] mb-6" data-id="element-172">
            El Protocolo de 3 Fases
          </h2>
          <p className="text-lg text-[#6B7280] max-w-2xl mx-auto" data-id="element-173">
            Un sistema paso a paso diseñado para la biología de la mujer latina
            después de los 40.
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative" data-id="element-174">
          {/* Vertical line for mobile/desktop */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-gray-200 -z-10 transform md:-translate-x-1/2" data-id="element-175"></div>

          <div className="space-y-12" data-id="element-176">
            {phases.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-177">
                {/* Content Card */}
                <div className="flex-1 w-full md:w-auto pl-20 md:pl-0" data-id="element-178">
                  <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 relative" data-id="element-179">
                    <span className="absolute -top-3 right-6 bg-[#064E3B] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-180">
                      {item.days}
                    </span>
                    <h3 className="text-xl font-bold text-[#1F2937] mb-2" data-id="element-181">
                      {item.title}
                    </h3>
                    <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-182">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Center Icon */}
                <div className="absolute left-8 md:left-1/2 transform -translate-x-1/2 w-16 h-16 bg-white rounded-full border-4 border-white shadow-md flex items-center justify-center z-10" data-id="element-183">
                  <div className={`w-12 h-12 ${item.bg} rounded-full flex items-center justify-center ${item.color}`} data-id="element-184">
                    <item.icon size={24} strokeWidth={2} data-id="element-185" />
                  </div>
                </div>

                {/* Empty space for alignment */}
                <div className="flex-1 hidden md:block" data-id="element-186"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}